import ReferAFriendDialog from './ReferAFriendDialog';
import ConnectedReferAFriendDialog from './ConnectedReferAFriendDialog';

export { ReferAFriendDialog };
export default ConnectedReferAFriendDialog;
